module.exports = __webpack_public_path__ + "img/paypal-alternative2.6bf3eb25.png";